import React from "react";
import { useFormikContext } from "formik";
import AlertCircle from "atd-icons/dist/AlertCircle";

const SelectInput = ({
  options = [],
  placeholder = "",
  label = "",
  name = "",
  className = "",
  onChange,
}) => {
  const formik = useFormikContext();

  const hasError =
    !!formik.errors?.[name] &&
    formik.values?.[name] !== formik?.initialValues?.[name];

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    } else {
      formik.setFieldValue(name, e.target.value);
    }
  };
  return (
    <div className={"relative w-full"}>
      <div
        className={`pointer-events-none absolute transition-all 0.3s ease text-[#B7BAC7] z-[5] ${formik.values?.[name] ? "text-[10px] top-[4px] bg-[#ffffff50] left-[16px]" : "text-base top-[14px] left-[16px]"}`}
      >
        {label && (
          <label className={`block p-[2px]`} htmlFor={name}>
            {label}
          </label>
        )}
      </div>
      {formik.values?.[name] && (
        <div
          className={`absolute transition-all 0.3s ease text-[#434343] z-[5] text-base top-[14px] left-[16px] ${formik.values?.[name] ? "opacity-100" : "opacity-0"}`}
        >
          <personalbar className={`block p-[2px]`}>
            {formik.values?.[name]}
          </personalbar>
        </div>
      )}
      <select
        name={name}
        id={name}
        onChange={handleChange}
        className={`bg-[#f9f9f9] text-[#434343] flex h-9 w-full rounded-md border border-input text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 py-[28px] px-[16px] appearance-none ${className}`}
      >
        <option value=""></option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        <option value="Maybe">Maybe</option>
      </select>
      {formik.touched?.[name] && formik.errors?.[name] && (
        <div className="flex gap-[4px] items-center mt-[6px]">
          <AlertCircle color="#DC2626" size={16} />
          <p className="text-[13px] text-[#DC2626] font-meedium">
            {formik.errors?.[name]}
          </p>
        </div>
      )}
    </div>
  );
};

export default SelectInput;
